import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['link'];

  connect() {
    //console.log('Button controller connected');
  }

  handleClick(event) {
    event.preventDefault();
    event.stopPropagation();
    const link = event.currentTarget;
    const type = link.getAttribute('data-link-type');
    const id = link.getAttribute('data-link-id');

    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    fetch('/students/update_favorites', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken
      },
      body: JSON.stringify({ type: type, id: id })
    })
      .then(response => response.json())
      .then(data => {
        console.log(data.result);

        if (data.result == "success"){
          if (link.classList.contains('badge-blue')){
            link.classList.add('badge-secondary');
            link.classList.remove('badge-blue');
          }else{
            link.classList.add('badge-blue');
            link.classList.remove('badge-secondary');
          }          
        }
      })
      .catch(error => {
        // Handle any errors
      });
  }
}
